import { render, staticRenderFns } from "./LogsTemplate.vue?vue&type=template&id=58a1327b&scoped=true"
import script from "./LogsTemplate.vue?vue&type=script&lang=js"
export * from "./LogsTemplate.vue?vue&type=script&lang=js"
import style0 from "./LogsTemplate.vue?vue&type=style&index=0&id=58a1327b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58a1327b",
  null
  
)

export default component.exports